"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountString = exports.numFormatter = void 0;
function numFormatter(num) {
    if (typeof num === 'string') {
        num = parseFloat(num);
    }
    if (typeof num !== 'number') {
        return '';
    }
    if (num < 1000) { //parseFloat then toString to truncate trailing 0s
        return parseFloat(num.toFixed(2)).toString();
    }
    const zeroRegex = /\.?0+$/;
    num /= 1000;
    if (num < 1000) {
        return num.toFixed(1).replace(zeroRegex, '') + "K";
    }
    num /= 1000;
    if (num < 1000) {
        return num.toFixed(1).replace(zeroRegex, '') + "M";
    }
    num /= 1000;
    if (num < 1000) {
        return num.toFixed(1).replace(zeroRegex, '') + "B";
    }
    num /= 1000;
    if (num < 1000) {
        return num.toFixed(1).replace(zeroRegex, '') + "T";
    }
    num /= 1000;
    if (num < 1000) {
        return num.toFixed(1).replace(zeroRegex, '') + "Qua";
    }
    num /= 1000;
    if (num < 1000) {
        return num.toFixed(1).replace(zeroRegex, '') + "Qui";
    }
    return num.toString();
}
exports.numFormatter = numFormatter;
function getCountString(count, maxFractionDigits = 0) {
    return count == null ? '-' : Number(count).toLocaleString('en-US', { maximumFractionDigits: maxFractionDigits });
}
exports.getCountString = getCountString;
//# sourceMappingURL=formatUtils.js.map